export const getWidgetsOptionsSelector = state => state?.widgets?.get('options')

export const getWidgetsFilter = state => state?.widgets?.get('filter')

export const getServiceOrderCountSelector = state =>
  state?.widgets?.getIn(['results', 'serviceOrderCount'])

export const getWidgetsListSelector = state => state?.widgets?.get('list')
